import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { WebGamesFiltersListenerEffect } from '../effects/web-games-filters-listener.effect';
import {
  addPagination,
  filterGamesByTitle,
  resetPagination,
} from '../store/slices/web-game.slice';

export const webGamesFiltersListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  webGamesFiltersListener.startListening({
    matcher: isAnyOf(addPagination, resetPagination, filterGamesByTitle),
    effect: WebGamesFiltersListenerEffect,
  });
